const notificationHubConnection = new signalR.HubConnectionBuilder()
    .withUrl("/numberPortHub")
    .configureLogging(signalR.LogLevel.Warning)
    .build();

async function registerNumberPortHub(id, recordChanged) {
    notificationHubConnection.on("OnRecordChanged", function (obj) {
        if (id && obj.id !== id) {
            return;
        }
        
        recordChanged(obj);
    });

    const start = async () => {
        try {
            await notificationHubConnection.start();
        } catch (err) {
            console.log(err);
            setTimeout(start, 5000);
        }
    };

    notificationHubConnection.onclose(start);
    await start();
}